<ion-range [min]="to.data ? to.data.minValue : 0" [max]="to.data ? to.data.maxValue : 100"
	[step]="to.data ? to.data.step : 1" [pin]="to.data ? to.data.pin : true" [dualKnobs]="to.data ? to.data.range : null"
	[(ngModel)]="model[fieldKey]" (ionChange)="onModelChanged()">
	<ion-label slot="start">{{to.data ? to.data.minValue : null}}</ion-label>
	<ion-label slot="end">{{to.data ? to.data.maxValue : null}}</ion-label>
</ion-range>